import { Button, Text, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { API_ROUTERS, ROUTERS } from '../../../data';
import { useAuthContext, useRequest, useToggle } from '../../../hooks';
import { UserProfileConfirmDeleting } from '../../Modals/UserProfileConfirmDeleting';
import { UserProfileHaveActiveVisit } from '../../Modals/UserProfileHaveActiveVisit';
import { UserProfileHaveMembers } from '../../Modals/UserProfileHaveMembers';

const MODAL_TYPES = {
  CONFIRM: 'CONFIRM',
  ACTIVE_MEMBERS: 'ACTIVE_MEMBERS',
  ACTIVE_SESSION: 'ACTIVE_SESSION',
};

export const DeleteProfile = () => {
  const { t } = useTranslation();
  const { show, isShow, hide } = useToggle();
  const { authRequest } = useRequest();
  const { signOut } = useAuthContext();
  const navigate = useNavigate();

  const onConfirmDeleting = async () => {
    try {
      await authRequest({ method: 'delete', url: API_ROUTERS.VISITOR });
      signOut({ nextRoute: ROUTERS.PROFILE_DELETED });
    } catch (e: any) {
      switch (e?.data?.code) {
        case 1:
          show({ type: MODAL_TYPES.ACTIVE_SESSION });
          break;
        case 2:
          show({ type: MODAL_TYPES.ACTIVE_MEMBERS });
          break;
      }
    }
  };

  return (
    <>
      <Flex alignItems='center' fontSize='sm' flexWrap='wrap'>
        <Text mr={1.5} width={{ base: '100%', lg: 'initial' }} mb={{ base: 4, lg: 'initial' }}>
          {t('profile.delete.label')}
        </Text>
        <Button
          variant='linkUnderline'
          fontSize='sm'
          color='gray.400'
          onClick={() => show({ type: MODAL_TYPES.CONFIRM })}
        >
          {t('profile.delete.btn')}
        </Button>
      </Flex>

      {/* ──── Modals ──────────────────────────────────────────────────────────────────────────── */}
      <UserProfileConfirmDeleting
        isOpen={isShow?.type === MODAL_TYPES.CONFIRM}
        onClose={hide}
        onConfirm={onConfirmDeleting}
      />
      <UserProfileHaveMembers
        isOpen={isShow?.type === MODAL_TYPES.ACTIVE_MEMBERS}
        onClose={hide}
        onConfirm={() => navigate(ROUTERS.USER.MEMBERS)}
      />
      <UserProfileHaveActiveVisit isOpen={isShow?.type === MODAL_TYPES.ACTIVE_SESSION} onClose={hide} />
    </>
  );
};
